import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'КОНСУЛЬТАЦІЯ',
  desc: 'До 5 хвилин. Вислуховуємо ваш запит та визначаємо перспективи справи.'
}, {
  num: '02',
  title: 'АЛГОРИТМ',
  desc: 'Розповідаємо чіткий покроковий план дій, узгоджуємо деталі та вартість.'
}, {
  num: '03',
  title: 'ВИРІШЕННЯ',
  desc: 'Беремо всю юридичну роботу на себе та доводимо справу до результату.'
}];
export function Process() {
  return <section className="border-y-2 border-black bg-white" data-id="element-75">
      <div className="max-w-[1400px] mx-auto" data-id="element-76">
        <div className="grid grid-cols-1 lg:grid-cols-4 divide-y-2 lg:divide-y-0 lg:divide-x-2 divide-black" data-id="element-77">
          <div className="p-8 lg:p-12 bg-black text-white flex flex-col justify-center" data-id="element-78">
            <h2 className="text-5xl font-bold mb-4" data-id="element-79">ЯК МИ ПРАЦЮЄМО</h2>
            <p className="text-lg font-medium" data-id="element-80">
              Прозорий процес. Цінуємо ваш час та одразу переходимо до суті.
            </p>
          </div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 lg:p-12 flex flex-col bg-white hover:bg-[#F4F4F5] transition-colors" data-id="element-81">
              <span className="text-6xl font-bold mb-6 block" data-id="element-82">{step.num}</span>
              <h3 className="text-2xl font-bold mb-4" data-id="element-83">{step.title}</h3>
              <p className="text-base font-medium" data-id="element-84">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}